
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, BaseFormSubmit, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues = computed(() => {
      return {
        email: store.state.user.user?.email
      }
    })

    const schema = yup.object({
      email: yup.string().required().email().max(255),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: email } = useField<string>('email')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/confirm-email', values)
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('account.change_email.send_email')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      onSubmit,
      btnDisabled
    }
  },
})
